module.exports = __webpack_public_path__ + "static/hunter-douglas-shades-c873ebc54a946813aa57589c53558533.png";